import React, { FC, useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import styles from './ScanIdComponent.module.scss';

interface ScanIdComponentProps {
    scanId: string,
    expandOnHover?: boolean,
    initialWidth?: number,
}

const ScanIdComponent: FC<ScanIdComponentProps> = (props) => {
    const { scanId, expandOnHover, initialWidth } = props;
    const copyText = 'Click to copy';

    const [tooltip, setTooltip] = useState(copyText);
    const [isHovered, setIsHovered] = useState(false);
    const copy = () => {
        navigator.clipboard.writeText(scanId).then(() => setTooltip('Copied'));
    };

    const mouseLeave = () => {
        setIsHovered(false);
        setTimeout(() => setTooltip(copyText), 250);
    };

    return (
        <Box
            component="span"
            sx={{
                position: 'relative',
                display: 'inline-block',
                height: '1.5rem',
            }}
        >
            <Tooltip title={tooltip} placement="top-start">
                <Box
                    data-testid="ScanIdComponent"
                    component="span"
                    sx={{
                        maxWidth: `${initialWidth}px`,
                        mr: 1,
                        overflow: 'hidden',
                        display: 'inline-block',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        height: 'auto',
                        ...(isHovered && expandOnHover && {
                            color: 'primary.main',
                            position: 'absolute',
                            maxWidth: 'none',
                            backgroundColor: '#fff',
                            zIndex: 100,
                            overflow: 'visible',
                        }),
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => mouseLeave()}
                    onClick={() => copy()}
                    className={styles.ScanIdComponent}
                >
                    {scanId}
                </Box>
            </Tooltip>
        </Box>
    );
};

export default ScanIdComponent;

ScanIdComponent.defaultProps = {
    expandOnHover: true,
    initialWidth: 90,
};
